import { useContext } from 'react';
import { SyncContext } from '@monorepo/shared';

function useSync() {
  const context = useContext(SyncContext);
  if (context === null) {
    throw new Error('useSync must be used within a SyncProvider');
  }
  return context;
}

export default useSync;
